import React, { createContext, useContext, useRef } from "react";

/**
 * Provides a ref to the top-bar global search input so app-level keyboard
 * shortcuts (like `/`) can focus it from anywhere.
 */
const SearchFocusContext = createContext({ ref: null, focus: () => {} });

export const SearchFocusProvider = ({ children }) => {
  const ref = useRef(null);
  const focus = () => {
    const el = ref.current;
    if (el && typeof el.focus === "function") {
      el.focus();
      // move cursor to end
      try {
        const len = el.value?.length || 0;
        el.setSelectionRange(len, len);
      } catch { /* not a text input */ }
    }
  };
  return (
    <SearchFocusContext.Provider value={{ ref, focus }}>
      {children}
    </SearchFocusContext.Provider>
  );
};

export const useSearchFocus = () => useContext(SearchFocusContext);
